<template>
  <div v-show="isOpen" class="popup">
    <div class="popup__shim" @click="closePopup"></div>
    <div class="popup__body">
      <div v-if="title" class="popup__title">{{ title }}</div>
      <div class="popup__content">
        <slot />
        <button v-show="buttonVisible" class="popup__button" @click="closePopup">
          {{ buttonText }}
          </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalsPopup',

  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },

    buttonText: {
      type: String,
      required: false,
      default: 'Geef weer',
    },

    showButton: {
      type: Boolean,
      required: false,
      default: true,
    },

    open: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    isOpen() {
      return this.open;
    },

    buttonVisible() {
      return this.showButton;
    },
  },

  methods: {
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
  .popup {
    align-items: center;
    background-color: rgba($color-white, .5);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: get-z-index();

    &__shim {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &__body {
      background-color: $color-white;
      border-radius: $global-radius;
      box-shadow: 0 4px 10px rgba($color-silver, .5);
      overflow: hidden;
      position: relative;
      width: 250px;
    }

    &__title {
      @include font-size(iota);

      background-color: $color-cerulean;
      color: $color-white;
      padding: $global-spacing-unit-quarter 0;
      text-align: center;
      text-transform: uppercase;
    }

    &__content {
      padding: $global-spacing-unit-threequarter;
    }

    &__button {
      @include font-size(theta);

      background-color: $color-cerulean;
      border: 0;
      border-radius: $global-radius;
      color: $color-white;
      display: block;
      margin-top: $global-spacing-unit-threequarter;
      padding: $global-spacing-unit-quarter $global-spacing-unit-half;
      width: 100%;
    }
  }
</style>
